import { render, staticRenderFns } from "./OrderAddressInfo.vue?vue&type=template&id=7413db6d&scoped=true"
import script from "./OrderAddressInfo.vue?vue&type=script&lang=js"
export * from "./OrderAddressInfo.vue?vue&type=script&lang=js"
import style0 from "./OrderAddressInfo.vue?vue&type=style&index=0&id=7413db6d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7413db6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7413db6d')) {
      api.createRecord('7413db6d', component.options)
    } else {
      api.reload('7413db6d', component.options)
    }
    module.hot.accept("./OrderAddressInfo.vue?vue&type=template&id=7413db6d&scoped=true", function () {
      api.rerender('7413db6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/goods/OrderAddressInfo.vue"
export default component.exports